<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="批次号：" prop="batch">
                <span>{{model.batch}}</span>
            </el-form-item>
            <el-form-item label="设备编号：" prop="device_no">
                <span>{{model.device_no}}</span>
            </el-form-item>
            <el-form-item label="设备名称：" prop="device_name">
                <span>{{model.device_name}}</span>
            </el-form-item>
            <el-form-item label="设备IP：" prop="device_ip">
                <span>{{model.device_ip}}</span>
            </el-form-item>
            <el-form-item label="数据时间：" prop="datetime">
                <span>{{model.datetime}}</span>
            </el-form-item>
            <el-form-item label="数据：" prop="data_str">
                <span>{{model.data_str}}</span>
            </el-form-item>
            <el-form-item label="上传时间：" prop="upload_time">
                <span>{{model.upload_time}}</span>
            </el-form-item>
            <el-form-item label="上传状态：" prop="upload_state">
                <span>{{ transEnu(model.upload_state, "upload_state") }}</span>
            </el-form-item>
            <el-form-item label="备注：" prop="upload_state">
                <span>{{model.remark}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'offLineFileInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                batch: '',
                device_no: '',
                device_name: '',
                device_ip: '',
                datetime: '',
                data_str: '',
                upload_time: '',
                upload_state: '',
                remark: '',
            },
            getObj:{
                url:'/api/admin/offlinefile/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['upload_state'],
        };
    },
    methods: {}
};
</script>